var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('EvolucionUci',{attrs:{"medical_act_id":_vm.medical_act_id,"addEv":_vm.addEv,"dete_out":_vm.dete_out,"dete_out_doctor":_vm.dete_out_doctor,"rolname":_vm.rolname,"typeDoctor":_vm.typeDoctor},on:{"mtdSaveEditedEvolution":function($event){return _vm.$emit('mtdSaveEditedEvolution')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }